import { fromBase64 } from "@cosmjs/encoding";

export const base64ToString = (hex: string) => {
  if (hex) {
    return new TextDecoder().decode(fromBase64(hex));
  }
  return "";
};
